import { createContext } from 'react';

import type { TruncationMode } from '../../../typography/text-ellipsis/TextEllipsis.js';
import { DEFAULT_TRUNCATION_MODE } from '../../core/constants.js';

export const HistogramTruncationModeContext = createContext<TruncationMode>(
  DEFAULT_TRUNCATION_MODE,
);

HistogramTruncationModeContext['displayName'] =
  'HistogramTruncationModeContext';
